/** Max viewport width for narrow layout switches (trays, chat-first, stacked shells). */
export const DASHLY_LAYOUT_NARROW_MAX_PX = 900;

/** `window.matchMedia` query. Keep the pixel value in sync with `_layout-breakpoints.scss`. */
export const DASHLY_LAYOUT_NARROW_MEDIA = `(max-width: ${DASHLY_LAYOUT_NARROW_MAX_PX}px)`;
